import { Truck, PackageCheck, HardHat, User } from "lucide-react";

export const CONTACT_TYPES = ["Proveedor", "Suministrador", "Industrial/Gremio", "Otro"];

export const CONTACT_TYPE_META = {
  "Proveedor": { icon: Truck, className: "bg-sky-100 text-sky-800 border-sky-200" },
  "Suministrador": { icon: PackageCheck, className: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  "Industrial/Gremio": { icon: HardHat, className: "bg-amber-100 text-amber-900 border-amber-200" },
  "Otro": { icon: User, className: "bg-stone-100 text-stone-700 border-stone-200" },
};
